import React, { useState, useEffect } from 'react';
import { Modal, Form, Button } from "react-bootstrap";
import { BASE_URL } from "../../../constants";
import axios from 'axios';

//const DiscountModal = ({ show, handleClose, handleSave }) => {
const EditAllotParkModal = ({ show, handleClose, onRowSelect }) => {


  const [searchFWDesc, setSearchFWDesc] = useState();
  const [searchResults, setSearchResults] = useState([]);

  useEffect(() => {

    const fetchLists = async () => {
      try {

        const response = await axios.get(`${BASE_URL}/api/get_mst_fees_waiver`, { params: { p_FW_Desc: '' } });

        setSearchResults(response.data);

      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }

    };

    fetchLists();

  }, []);

  const handleSearch = async () => {

    try {

      const response = await axios.get(`${BASE_URL}/api/get_mst_fees_waiver`, { params: {p_FW_Desc: searchFWDesc || ''} });

      setSearchResults(response.data);

    } catch (error) {

      console.error('Search failed:', error);

    }

  };

  const handleClear = async () => {

    setSearchFWDesc('');
    setSearchResults([]);

  }
  
  return (

    <Modal show={show} onHide={handleClose} size="lg" centered backdrop="static" keyboard={false}>

      <Modal.Header closeButton>
        <Modal.Title>Select Fees Waiver - Edit</Modal.Title>
      </Modal.Header>

      <Modal.Body>

        <Form className="mb-3">
          {/* === Row 1 === */}
          <div className="row mb-3">

            <Form.Group className="col-md-8">
                <input value={searchFWDesc} placeholder='Waiver Description' className="form-control"
                  onChange={(e) => setSearchFWDesc(e.target.value)}>
                </input>
            </Form.Group>

            <div className="col-md-2">
              <Button variant="primary" onClick={handleSearch} className="w-100">
                Search
              </Button>
            </div>
            <div className="col-md-2">
                 <Button variant="secondary" onClick={handleClear} className="w-100">
                Clear
              </Button>
            </div>

          </div>

        </Form>
        {/* <Table bordered hover responsive> */}
        <div style={{ minHeight: '430px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table-modal scty-custom-table hover-table-rcpt">
            <thead>
              <tr>
                <th style={{ width: '20%', textAlign: 'left' }}>Waiver Description</th>
                <th style={{ width: '8%', textAlign: 'left' }}>Waiver Type</th>
                <th style={{ width: '8%', textAlign: 'left' }}>Category</th>
                <th style={{ width: '8%', textAlign: 'left' }}>Status</th>
              </tr>
            </thead>
            <tbody>
              {searchResults.length === 0 ? (
                <tr><td colSpan="4" className="text-center">No Data</td></tr>
              ) : (
                searchResults.map((row, index) => (
                  <tr key={index} onClick={() => onRowSelect(row)} style={{ cursor: 'pointer' }}>
                    <td style={{ textAlign: 'left' }}>{row.fw_desc}</td>
                    <td style={{ textAlign: 'left' }}>{row.fw_type}</td>
                    <td style={{ textAlign: 'left' }}>{row.fw_catg}</td>
                    <td style={{ textAlign: 'left' }}>{row.status}</td>
                  </tr>
                ))
              )}
            </tbody>
            {/* </Table> */}
          </table>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditAllotParkModal;
